import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PlayerDeviceOption {
    id: string;
    name: string;
    description: string;
    icon: string;
    color: string;
    badge?: string;
    features: string[];
    actionLabel: string;
    actionIcon: string;
    link?: string;
    isDownload?: boolean;
}

@Component({
    selector: 'app-dialog-player-devices',
    templateUrl: './dialog-player-devices.component.html',
    styleUrls: ['./dialog-player-devices.component.scss']
})
export class DialogPlayerDevicesComponent implements OnInit {

    playerOptions: PlayerDeviceOption[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<DialogPlayerDevicesComponent>
    ) {}

    ngOnInit(): void {
        this.initPlayerOptions();
    }

    private initPlayerOptions(): void {
        this.playerOptions = [
            {
                id: 'mediadroid',
                name: 'mediaDROID X Pro',
                description: 'plug and play digital signage player pre loaded with our software',
                icon: 'smart_display',
                color: '#FF9900',
                badge: 'recommended',
                features: [
                    '4K Ultra HD output',
                    'pre installed software',
                    'commercial grade 24 7',
                    'compact and silent',
                    'remote management'
                ],
                actionLabel: 'buy on amazon',
                actionIcon: 'shopping_cart',
                link: 'https://www.amazon.com/mediaDROID-X-Pro-Powered-Signage-DigitalSignage-com/dp/B076X6H2KR'
            },
            {
                id: 'raspberry',
                name: 'Raspberry Pi 5',
                description: 'affordable DIY solution for digital signage',
                icon: 'developer_board',
                color: '#C51A4A',
                features: [
                    'minimum 2GB RAM',
                    'cost effective solution',
                    'easy software install',
                    'great for prototyping',
                    'community support'
                ],
                actionLabel: 'setup guide',
                actionIcon: 'menu_book',
                link: 'https://digitalsignage.com/_html/raspberry_pi_digital_signage.html'
            },
            {
                id: 'windows',
                name: 'Windows PC',
                description: 'run on any Windows 10 or 11 computer',
                icon: 'desktop_windows',
                color: '#0078D4',
                features: [
                    'Windows 10 or 11',
                    'free software download',
                    'full feature support',
                    'touch screen ready',
                    'use existing hardware'
                ],
                actionLabel: 'download',
                actionIcon: 'download',
                link: 'https://galaxy.signage.me/signstudio/shopping-cart/downloads'
            },
            {
                id: 'linux',
                name: 'Linux',
                description: 'debian based distributions supported',
                icon: 'terminal',
                color: '#F15B06',
                features: [
                    'Ubuntu and Debian',
                    'free software download',
                    'lightweight option',
                    'server deployments',
                    'command line install'
                ],
                actionLabel: 'download',
                actionIcon: 'download',
                link: 'https://galaxy.signage.me/signstudio/shopping-cart/downloads'
            }
        ];
    }

    onSelectOption(option: PlayerDeviceOption): void {
        if (option.link) {
            window.open(option.link, '_blank');
        } else if (option.isDownload) {
            this.dialogRef.close({ action: 'download', device: option.id });
        }
    }

    onLearnMore(): void {
        window.open('https://digitalsignage.com/_html/digitalsignage_devices.html', '_blank');
    }
}
